/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { SecurityRequirement } from '../../core/models/common/SecurityRequirement';

/**
 * Models an OpenAPI security requirement.
 * @author eric.wittmann@gmail.com
 * @class
 * @extends SecurityRequirement
 */
export abstract class OasSecurityRequirement extends SecurityRequirement {
    constructor() {
        super();
    }
}
OasSecurityRequirement["__class"] = "io.apicurio.datamodels.openapi.models.OasSecurityRequirement";
OasSecurityRequirement["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




